import { projects as actionTypes } from "store/constants";
import { getStoredProposalsContent } from "utils";
import {
	fetchableInitialState,
	reduceIsFetching,
	reduceSetError,
} from "store/factories/fetchable";
import {
	reduceSetItems,
	reduceSetSort,
	reduceSetPaging,
	addItems,
	reduceSetSearch,
} from "store/factories/feed";
import { baseInitialState } from "store/factories/initialState";


const initialState = {
	content: {
		...fetchableInitialState,
		...((getStoredProposalsContent && getStoredProposalsContent()) ?? baseInitialState.content),
	},
	summary: {
		...fetchableInitialState,
		items: [],
	},
};

export function projectList(state = initialState, action) {
	switch (action.type) {
		case actionTypes.PROJECT_LIST_IS_FETCHING:
			return {
				...state,
				content: reduceIsFetching(state.content, action),
			};
		case actionTypes.PROJECT_LIST_SET_ERROR:
			return {
				...state,
				content: reduceSetError(state.content, action.payload),
			};
		case actionTypes.PROJECT_LIST_SET_DATA:
			return {
				...state,
				content: {
					...state.content,
					...action.payload,
				},
			};

		case actionTypes.PROJECT_LIST_SUMMARY_IS_FETCHING:
			return {
				...state,
				summary: reduceIsFetching(state.summary, action),
			};
		case actionTypes.PROJECT_LIST_SUMMARY_SET_ERROR:
			return {
				...state,
				summary: reduceSetError(state.summary, action.payload),
			};
		case actionTypes.PROJECT_LIST_SUMMARY_SET_DATA:
			return {
				...state,
				summary: {
					...state.content,
					items: action.payload,
				},
			};

	case actionTypes.SET_ITEMS:
		return reduceSetItems(state, action);
	case actionTypes.SET_SORT:
		return reduceSetSort(state, action);
	case actionTypes.SET_PAGING:
		return reduceSetPaging(state, action);
	case actionTypes.ADD_ITEMS:
		return addItems(state, action);
	case actionTypes.RESET:
		return initialState;
	case actionTypes.SET_SEARCH:
		return reduceSetSearch(state, action);
	default:
		return state;
	}
}


